import {
  TranslocoModule,
  TRANSLOCO_CONFIG,
  translocoConfig,
  TRANSLOCO_MISSING_HANDLER,
  TRANSLOCO_INTERCEPTOR,
  TRANSLOCO_FALLBACK_STRATEGY,
  DefaultFallbackStrategy,
  TranslocoInterceptor,
  Translation,
  DefaultTranspiler,
  TRANSLOCO_TRANSPILER,
  TranslocoService,
  TRANSLOCO_LOADER
} from '@ngneat/transloco';
import { environment } from '../environments/environment';
import { Injectable, NgModule } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UserSessionStorageService } from './data-access-layer/services/user-sessions.service';

@Injectable({ providedIn: 'root' }) export class TranslocoHttpLoader {
  constructor(private http: HttpClient) { } getTranslation(lang: string): Observable<any> {
    return this.http.get(`/assets/i18n/${lang}.json`);
  }
}

export class EmptyInterceptor implements TranslocoInterceptor {
  preSaveTranslation(translation: Translation, lang: string): Translation {
    return translation; // просто возвращаем объект без изменений
  }

  preSaveTranslationKey(key: string, value: string, lang: string): string {
    return value; // возвращаем значение без изменений
  }
}

export class EmptyMissingHandler {
  handle(key: string): string {
    return key;
  }
}

@NgModule({
  imports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: ['en', 'ru'],
        defaultLang: 'ru',
        reRenderOnLangChange: true,
        prodMode: environment.production,
        
      }),
    },
    { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
    { provide: TRANSLOCO_TRANSPILER, useClass: DefaultTranspiler },
    { provide: TRANSLOCO_MISSING_HANDLER, useClass: EmptyMissingHandler },
    { provide: TRANSLOCO_INTERCEPTOR, useClass: EmptyInterceptor },
    { provide: TRANSLOCO_FALLBACK_STRATEGY, useClass: DefaultFallbackStrategy }
  ]
})
export class TranslocoRootModule {
  constructor(private transloco: TranslocoService, public sessionService: UserSessionStorageService) {

    let lang = this.sessionService.getItem('lang');
    this.transloco.setActiveLang(lang ?? 'ru');
  }
}
